import { isNil } from 'lodash';
import { CSSProperties } from 'react';
import { StyleProp, ViewStyle } from 'react-native';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { EntityBatchField } from '@shared/data/entity/fields/EntityBatchField';
import { CardCollectionViewFieldContainer } from './CardCollectionViewFieldContainer';
import classNames from './EntityBatchCollectionViewField.module.css';

interface Props {
  field: EntityBatchField;
  style: StyleProp<ViewStyle>;
  textStyle?: CSSProperties;
}

export function EntityBatchCollectionViewField({ field, style, textStyle }: Props) {
  const schedule = field.refs.find(ref => ref.id === field.id);
  if (isNil(schedule)) {
    return null;
  }

  return (
    <CardCollectionViewFieldContainer style={style}>
      <View className={classNames.container}>
        <Text size="body1" className={classNames.text} style={textStyle}>
          {schedule.name}
        </Text>
      </View>
    </CardCollectionViewFieldContainer>
  );
}
